import { render, staticRenderFns } from "./UpsertShip.vue?vue&type=template&id=9d5db0b0"
import script from "./UpsertShip.vue?vue&type=script&lang=ts"
export * from "./UpsertShip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports